// import router from "../../router";
//import eventBus from "../../../main";
//import jwtDecode from "jwt-decode";

import eventBus from "../../../../main";
import apiServices from "../../../../../services/apiServices";

export default {
  state: {
    datasetEnterprise: {
      after: ""
    },
    enterprise: {
      balance: "",
      mcx: {
        openConfirmCreditWallet: false,
        closeSetCreditWallet: true,
        amount: ""
      },
      bank: {
        account: "",
        transaction: {}
      },
      wlt: {
        openConfirmTransWallet: false,
        closeSetTransWallet: true,
        amount: "",
        destiny: "",
        bankToTransfer: "",
        transaction: ""
      }
    }
  },
  mutations: {
    SET_BALANCE_WALLET_ENTERPRISE(state, value) {
      state.enterprise.balance = value;
    },
    SET_BANK_ACCOUNT_ENTERPRISE(state, value) {
      state.enterprise.bank.account = value;
    },
    SET_CONFIRM_CREDIT_WALLET_ENTERPRISE(state, value) {
      state.enterprise.mcx.openConfirmCreditWallet = value.target;
      state.enterprise.mcx.amount = value.amount;
      state.enterprise.mcx.closeSetCreditWallet = value.close;
    },
    SET_CONFIRM_TRANSFER_WALLET_ENTERPRISE(state, value) {
      state.enterprise.wlt.openConfirmTransWallet = value.target;
      state.enterprise.wlt.amount = value.amount;
      state.enterprise.wlt.closeSetTransWallet = value.close;
      state.enterprise.wlt.bankToTransfer = value.ck;
    },

    SET_WALLET_ACCOUNT_NAME_ENTERPRISE(state, value) {
      state.enterprise.wlt.destiny = value;
    },

    SET_TRANSACTIONS_ENTERPRISE(state, value) {
      state.enterprise.bank.transaction = value;
    },
    SET_DATASET_AFTER_ENTERPRISE(state, value) {
      state.dataset.after = value;
    }
  },
  actions: {
    setDataSetAfterE(context, value) {
      context.commit("SET_DATASET_AFTER_ENTERPRISE", value);
    },
    setBalanceWalletClientE(context, value) {
      context.commit("SET_BALANCE_WALLET_ENTERPRISE", value);
    },
    setConfirmCreditWalletE(context, value) {
      context.commit("SET_CONFIRM_CREDIT_WALLET_ENTERPRISE", value);
    },
    setConfirmTransWalletEnterprise(context, value) {
      context.commit("SET_CONFIRM_TRANSFER_WALLET_ENTERPRISE", value);
      context.commit("SET_WALLET_ACCOUNT_NAME_ENTERPRISE", "");
    },

    //Transfer money to another wallet
    confirmTransferToAnotherWalletE(context, value) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      const data = {
        ck: value.ck
      };
      apiServices
        .confirmTransferToWallets(data)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              context.commit("SET_CONFIRM_TRANSFER_WALLET_ENTERPRISE", value);
              context.commit(
                "SET_WALLET_ACCOUNT_NAME_ENTERPRISE",
                obj.message[0]
              );
            } else {
              let payload = {
                color: "error",
                right: "center",
                top: "top",
                text: "Ups! Seu pedido não foi processado",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error")
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus

          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },

    //Confirm Transfer to another wallet
    transferToAnotherWalletE(context) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      apiServices
        .transferToWallets({
          amount: context.getters.getAmountToSetWalletEnterprise,
          to: context.getters.getBankToTransferEnterprise
        })
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              let payload = {
                color: "success",
                right: "center",
                top: "top",
                text: "A sua transferência foi realizada com sucesso!",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            } else {
              let payload = {
                color: "error",
                right: "center",
                top: "top",
                text: "Ups! Seu pedido não foi processado",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error")
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },

    //Charge wallet
    chargeWithWalletE(context, value) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      apiServices
        .chargeWithWallets(JSON.stringify(value))
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200) {
              let payload = {
                color: "success",
                text: "Carteira carregada com sucesso",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            } else {
              let payload = {
                color: "error",
                text: "Ups! Verifique as suas credenciais",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center"
          };
          if (error == "Error: Network Error")
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center"
            }); // emit the event to the bus
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },
    //Get Bank Account wallet
    getBankAccountE(context) {
      return apiServices
        .getBankAccounts()
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              context.commit(
                "SET_BALANCE_WALLET_ENTERPRISE",
                obj.message[0].Saldo
              );
              context.commit(
                "SET_BANK_ACCOUNT_ENTERPRISE",
                obj.message[0].ContaKyami
              );
            }
          }
        })
        .catch(function() {})
        .finally(function() {
          //eventBus.$emit("openSpin", false);
        });
    },

    //Get transactions Billing
    getTransactionE(context) {
      //eventBus.$emit("openSpin", true); // emit the event to the bus
      return apiServices
        .getTransactions()
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              context.commit("SET_TRANSACTIONS_ENTERPRISE", obj.message);
            }
          }
        })
        .catch(function() {})
        .finally(function() {
          //eventBus.$emit("openSpin", false);
        });
    }
  },

  getters: {
    getBalanceEnterprise(state) {
      return state.enterprise.balance;
    },
    getConfirmCreditWalletEnterprise(state) {
      return state.enterprise.mcx.openConfirmCreditWallet;
    },
    getBankToTransferEnterprise(state) {
      return state.enterprise.wlt.bankToTransfer;
    },
    getAmountToSetEnterprise(state) {
      return state.enterprise.mcx.amount;
    },
    getAmountToSetWalletEnterprise(state) {
      return state.enterprise.wlt.amount;
    },
    getNameToTransferEnterprise(state) {
      return state.enterprise.wlt.destiny;
    },
    getCloseSetCreditWalletEnterprise(state) {
      return state.enterprise.mcx.closeSetCreditWallet;
    },
    getBanckAccountEnterprise(state) {
      return state.enterprise.bank.account;
    },
    getCloseSetTransWalletEnterprise(state) {
      return state.enterprise.wlt.closeSetTransWallet; //Close Modal trans
    },
    getConfirmTransWalletEnterprise(state) {
      return state.enterprise.wlt.openConfirmTransWallet; //Confirm trans
    },
    getTransactionToStoryWalletEnterprise(state) {
      return state.enterprise.bank.transaction;
    },
    getDataSetAfterEnterprise(state) {
      return state.datasetEnterprise.after;
    }
  }
};
